import Snackbar from '../Snackbar';

export default class TextWithLink extends Snackbar {
  static templateId = 'text-with-link';

  static elements = ['detailsContainer', 'textContainer', 'linkContainer'];

  constructor(...args) {
    super(...args);
    this.prepare();
  }

  prepare() {
    const { text, link } = this.options;

    this.textContainer.textContent = text;
    this.linkContainer.href = link.href;
    this.linkContainer.textContent = link.text;

    return this;
  }
}
